import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { MgButtonModule } from '@app/src/app/button';
import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { GenericButtonModule } from '@shared/components/button';
import { MembershipListTableModule } from '@shared/components/membership-list-table';
import { SettingsModule } from '@shared/components/settings/settings.module';
import { TextModule } from '@shared/components/text';
import { TooltipModule } from '@shared/components/tooltip';
import { LoadingPipesModule } from '@shared/pipes';

import { BmSettingsComponent } from './bm-settings.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgButtonModule,
    PermissionsModule,
    TooltipModule,
    MgEmptyStateModule,
    SettingsModule,
    GenericButtonModule,
    MgSpinnerModule,
    LoadingPipesModule,
    MembershipListTableModule,
    TextModule,

    // External dependencies
    CommonModule,
    MatSlideToggleModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    FlexLayoutModule,
  ],
  declarations: [BmSettingsComponent],
  exports: [BmSettingsComponent],
})
export class BmSettingsModule {}
